/**
 * 搜索结果页列表
 * @author wangyichen
 * @since 18/08/05
 */
import ACTIONS from 'constants/action.json5';

const initialState = {
  // 状态：0=已就绪，1=正在加载，2=加载失败，3=已加载所有数据
  status: 0,
  // 当前pageno，即byIds中的id
  id: 1,
  // 搜索结果列表
  byIds: [],
  // 搜索结果总数
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_CASE_ING: {
      return {
        ...state,
        status: 1,
      };
    }
    case ACTIONS.GET_CASE_SUCCEED: {
      const { id, list, total } = action.payload;
      return {
        ...state,
        status: 0,
        id,
        // todo 这里有问题
        byIds: list.length > 0 ? state['byIds'].concat([list]) : state['byIds'],
        total: total,
      };
    }
    case ACTIONS.GET_CASE_FAILED: {
      return {
        ...state,
        status: 2,
      };
    }
    case ACTIONS.GET_CASE_ENDED: {
      return {
        ...state,
        status: 3,
      };
    }
    default:
      return state;
  }
};
